export function sanitizeImportedSourceText(value = "") {
  return String(value || "")
    .replace(
      /\bImported by RPO AI Agent via JobSpy from\b/gi,
      "Imported by RPO AI Agent from"
    )
    .replace(/\bvia JobSpy\b/gi, "")
    .replace(/\bJOBSPY\b/g, "external job board search")
    .replace(/\bJobSpy\b/g, "external job board search")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+\./g, ".")
    .trim();
}
